<template>
  <div>
    <div class="glitchHolder">
      <div v-if="glitches" id="glitchOverlay" :style="{top:glitchTop+'px'}">
        <div
          v-for="g in glitches"
          class="glitchOver"
          :style="{marginBottom:g.pad+'px',width:g.width+'%'}"
        >
          <div
            v-for="gc in g.child"
            class="glitchChild"
            :style="{backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'}"
          ></div>
        </div>
      </div>
    </div>
    <v-container ma-0 pt-0 style="font-size:14px;">
      
      <v-layout>
        <v-flex xs12 offset-xs0 sm10 offset-sm2 pa-2>
           <v-layout v-if="true">
               <v-flex xs12  pt-0>
              <v-img  src="https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/Slider%2FLibertyLoop_website_banner.jpg?alt=media&token=6a02772f-13bb-431d-b73e-6f2f83876ef7"  width="100%" style="margin-top:10px;position:relative" > </v-img>
        </v-flex>
           </v-layout>
            <v-layout v-if="true">
             
        
              <v-flex v-if="false" xs6  pt-3 >
            <v-img  src="https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/Slider%2FLibertyLoop_fbbanner.jpeg?alt=media&token=68b0479c-e678-491d-96da-a6b584e30059"  width="360px" height="200px" style="margin-top:10px;position:relative" > </v-img>
          </v-flex>
              <v-flex xs9 pt-0>
                <br />
                <h2>LIBERTY LOOP: FILMS OF THE PEOPLE</h2>
                <h4>
                 <br>@ The Loop 157 Elizabeth Street, Hobart <br />
                  SCREENING DAILY 10AM – 3PM<br />
                  23 March – 9 May
                  <br/><br>
                
               </h4>

              </v-flex>
              
            </v-layout>
            

 <br>
 Complementing the inaugural Hobart Current: Liberty the City of Hobart is hosting a program of diverse community activities, providing opportunities to discover and explore the notion of ‘liberty’.
<br><br>
 

<b>Liberty Loop: Films of The People</b> is a film program from community and creators with diverse voices sharing stories of hotel quarantines, aquatic friendships, covid companions (the furry kind) and dance, dance, dance! The program invited creatives to reflect on the notion of ‘liberty’

The program has a little bit of everything from animates, films shorts, documentary and digital artwork and artist vlogs.<br><br>

For exhibition details and other events that are part of HOBART CURRENT: LIBERTY Public Programs, check out

 <v-btn href="https://hobartcurrent.com/" target="_blank" >Hobart Current: Liberty</v-btn> <br><br>

HOBART CURRENT is a biannual exhibition supported in partnership by The City of Hobart and Tasmanian Museum and Art Gallery.
<br><br>
Image: The LOOP screen located in the heart of Hobart. Artwork: Sunrise by Alicja Trefler, video still, 2012. Courtesy of The University of Tasmania. Photo: Joseph Shrimpton
<br><br>

<br>
 
               <v-flex xs12  pt-0>
              <v-img  src="https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/Slider%2FCurrent-footer.png?alt=media&token=497ce3ae-a7d7-47ae-b82b-2a40d2be55cb"  width="100%" style="margin-top:10px;position:relative" > </v-img>
        </v-flex>
           

<br>  

        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      glitches: null,
      glitchCount: 20,
      glitchTop: 0,
    };
  },
  mounted() {
    this.glitches = [];
    let childA = [];
    for (var i = 0; i < 8; i++) {
      childA = [];
      for (var p = 0; p < 2; p++) {
        childA.push(Math.floor(Math.random() * 100));
      }
      this.glitches.push({
        colour: "#00000044",
        height: 30,
        pad: 3,
        width: Math.random() * 50 + 50,
        child: childA,
      });
    }
    setTimeout(this.glitch, 100);
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
  },
  methods: {
    glitch() {
      this.glitchCount++;
      if (this.glitchCount > 50) {
        this.glitchCount = Math.random() * 20 - 10;
        this.glitchTop = Math.random() * 400 + 100;
      }
      if (this.glitchCount > 10) {
        this.glitchCount += Math.random() * 40;
        setTimeout(this.glitch, Math.random() * 100 + 100);

        return;
      }

      for (var g in this.glitches) {
        if (Math.random() * 10 > 7) {
          this.glitches[g].height = Math.random() * 20 + 5;
          for (var gc in this.glitches[g].child) {
            this.glitches[g].child[gc] = Math.floor(Math.random() * 160 + 20);
          }
          if (Math.random() * 10 > 5) {
            this.glitches[g].height = 0;
          }
        }
        this.glitches[g].pad = Math.floor(Math.random() * 5 + 5);
        this.glitches[g].width = Math.floor(Math.random() * 160 + 20);
      }
      if (Math.random() * 10 > 5) {
        // this.glitchTop=Math.random()*400+100;
      }
      setTimeout(this.glitch, 100);
    },
  },
};
</script>

<style scoped>
.glitchHolder {
  position: absolute;
  top: 0px;
  height: 100%;
  width: 100%;
  min-height: 100px;
  overflow: hidden;
  pointer-events: none;
}
#glitchOverlay {
  position: absolute;
  left: -100px;
  top: 0px;
}
.glitchOver {
  z-index: 3;
  position: relative;
  min-height: 30px;
  pointer-events: none;
  opacity: 0.3;
  width: 400px;
}
.glitchChild {
  width: 40px;
  display: inline-block;
  background-color: #00f;
}
</style>



// WEBPACK FOOTER //
// src/components/LibertyLoop.vue